import {apiWithToken} from '../../../systems/api';
import {API_URL} from './../../../systems/globalContant';

export default {
    updateWrongProcessOrder: (datas) => apiWithToken.put(API_URL.WRONG_PROCESS_ORDER.replace("{id}", datas.id) , {...datas}, {loading: false}),
};